<template>
  <div class="login text-darkBlue">
    <div class="text-center mt-3">
      <h1 class="font-semibold text-lg">Welcome Back !</h1>
      <p class="text-sm">Sign in to continue to MuleEx.</p>
    </div>

    <div class="w-full mx-auto px-3 py-4">
      <div v-if="!hasType" class="text-darkBlue">
        <!-- <div class="text-center w-full md:w-3/5 mx-auto my-12">
          <h1 class="text-lg md:text-3xl font-bold">Sign in as</h1>
        </div> -->

        <div class="w-full h-screen md:w-4/5 mx-auto font-semibold mt-12">
          <div class="flex gap-4 items-center">
            <div :class="{ selected: mainAccountType == '3PL', groupselected: onboardingType == '3PL' }"
              class="single-option shadow" @click="toggleAccountType('3PL')">
              <div class="single-option__inner">
                <div class="single-option__">
                  <p>{{ logisticsTitle }}</p>
                  <!-- <p>Organization</p> -->
                </div>

              </div>
              <div class="actions" v-if="mainAccountType == '3PL' && false">
                <div :class="{ selected: accountType == 'N/A' }" class="disabled-option single-option shadow" @click="
                  selectAccountType('N/A', 'logistics', 'Independent Partner')
                  ">
                  <div class="single-option__inner">
                    <div class="single-option__">
                      <p>Independent Partner</p>
                    </div>
                    <div class="single-option__select-circle">
                      <div class="single-option__select-circle__inner"></div>
                    </div>
                  </div>
                </div>
                <div :class="{ selected: accountType == 'organization' }" class="single-option shadow" @click="
                  selectAccountType(
                    'organization',
                    'logistics',
                    'Enterprise Partner'
                  )
                  ">
                  <div class="single-option__inner">
                    <div class="single-option__">
                      <p>Enterprise Partner</p>
                    </div>
                    <div class="single-option__select-circle">
                      <div class="single-option__select-circle__inner"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex gap-4 items-center">
            <div :class="{ selected: mainAccountType == 'ondemand', groupselected: onboardingType == 'ondemand' }"
              class="single-option shadow single-option" @click="toggleAccountType('ondemand')">
              <div class="single-option__inner">
                <div class="single-option__">
                  <p>Login as an {{ customerTitle }}</p>
                </div>
                <div class="single-option__select-circle">
                  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.75697 7L12.5139 1" stroke="#10233E" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <!-- <div class="single-option__select-circle__inner"></div> -->
                </div>
              </div>
              <div class="actions" v-if="mainAccountType == 'ondemand'">
                <div :class="{ selected: accountType == 'individual' }" class="single-option shadow" @click="
                  selectAccountType(
                    'individual',
                    'customer',
                    'Individual'
                  )
                  ">
                  <div class="single-option__inner">
                    <div class="single-option__">
                      <p>Individual (Private customer)</p>
                    </div>
                    <div class="single-option__select-circle">
                      <div class="single-option__select-circle__inner"></div>
                    </div>
                  </div>
                </div>

                <!-- <div :class="{ selected: accountType == 'enterprise_customer' }" class="single-option shadow" @click="
                  selectAccountType(
                    'enterprise_customer',
                    'customer',
                    'Organization (Enterprise customer)'
                  )
                  ">
                  <div class="single-option__inner">
                    <div class="single-option__">
                      <p>Organization (Enterprise Customer)</p>
                    </div>
                    <div class="single-option__select-circle">
                      <div class="single-option__select-circle__inner"></div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>



      <div v-if="hasType">
        <div class="mt-2" v-if="accountType == 'organization' || accountType == 'enterprise_customer'">
          <label class="label font-semibold">Domain</label>

          <div class="flex items-center">
            <base-input placeholder="Enter Your Domain" errorText="Please enter a valid Domain" class="w-full"
              v-model="user.accountId" />
            <tool-tip class="ml-1" text="This is  a unique name entered while creating your account to enable MuleEx allocate a unique workspace to your account.
            It is required for a Non-root user to login.
            Can't remember? Check your register email or contact your admin" />
          </div>
        </div>
        <div class="mt-2">
          {{ newUser }}
          <label class="label font-semibold">Email <span class="text-red-500">*</span></label>
          <base-input placeholder="Enter Your Email" errorText="Please enter a valid email Address" v-model="user.email"
            :validation="/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email)" @valid="validation.isValidEmail = true" @invalid="validation.isValidEmail = false">
            <template v-slot:icon>
              <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.941 0.283447H1.96132C1.63025 0.283447 1.31273 0.417552 1.07863 0.656259C0.84453 0.894966 0.713013 1.21872 0.713013 1.55631V11.7392C0.713013 12.0768 0.84453 12.4005 1.07863 12.6392C1.31273 12.8779 1.63025 13.012 1.96132 13.012H16.941C17.272 13.012 17.5896 12.8779 17.8237 12.6392C18.0578 12.4005 18.1893 12.0768 18.1893 11.7392V1.55631C18.1893 1.21872 18.0578 0.894966 17.8237 0.656259C17.5896 0.417552 17.272 0.283447 16.941 0.283447ZM15.5678 1.55631L9.45114 5.8713L3.33445 1.55631H15.5678ZM1.96132 11.7392V2.13546L9.09538 7.16962C9.19986 7.24352 9.32398 7.28313 9.45114 7.28313C9.5783 7.28313 9.70243 7.24352 9.80691 7.16962L16.941 2.13546V11.7392H1.96132Z"
                  fill="#FCC210" />
              </svg>
            </template>
          </base-input>
        </div>
        <div class="mt-2">
          <label class="label font-semibold">Password <span class="text-red-500">*</span></label>
          <base-input type="password" placeholder="Enter Your Password" revealPassword="true" v-model="user.password"
            :validation="user.password.length" @valid="validation.isValidPassword = true"
            @invalid="validation.isValidPassword = false">
            <template v-slot:icon>
              <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
                  stroke="#FCC210" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </template>
          </base-input>
        </div>
        <div></div>
        <div class="mt-8">
          <base-button text="Login" width="w-full" p="py-2" :disabled="false" :loading="loggingIn" @click="login" />
        </div>
        <p @click="hasType = false" class="text-sm text-center cursor-pointer text-primary-yellow pl-2 my-3">Login
          differently
        </p>
        <div class="flex justify-center items-center mt-2">
          <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.00004 0.666504C4.70254 0.666504 2.83337 2.53567 2.83337 4.83317V7.33317H2.00004C1.55801 7.33317 1.13409 7.50877 0.821529 7.82133C0.508969 8.13389 0.333374 8.55781 0.333374 8.99984V15.6665C0.333374 16.1085 0.508969 16.5325 0.821529 16.845C1.13409 17.1576 1.55801 17.3332 2.00004 17.3332H12C12.4421 17.3332 12.866 17.1576 13.1786 16.845C13.4911 16.5325 13.6667 16.1085 13.6667 15.6665V8.99984C13.6667 8.55781 13.4911 8.13389 13.1786 7.82133C12.866 7.50877 12.4421 7.33317 12 7.33317H11.1667V4.83317C11.1667 2.53567 9.29754 0.666504 7.00004 0.666504ZM4.50004 4.83317C4.50004 3.45484 5.62171 2.33317 7.00004 2.33317C8.37837 2.33317 9.50004 3.45484 9.50004 4.83317V7.33317H4.50004V4.83317ZM7.83337 13.769V15.6665H6.16671V13.769C5.87536 13.6022 5.64142 13.3509 5.49573 13.0485C5.35004 12.746 5.29944 12.4065 5.35061 12.0746C5.40178 11.7428 5.5523 11.4343 5.78234 11.1898C6.01239 10.9452 6.31114 10.7762 6.63921 10.7048C6.88289 10.651 7.13556 10.6525 7.37858 10.7092C7.6216 10.766 7.84878 10.8766 8.04336 11.0329C8.23794 11.1892 8.39497 11.3871 8.50285 11.6122C8.61074 11.8372 8.66673 12.0836 8.66671 12.3332C8.66623 12.6246 8.58895 12.9108 8.44265 13.1629C8.29635 13.4149 8.0862 13.624 7.83337 13.769Z"
              fill="#10233E" />
          </svg>
          <router-link :to="{ name: 'ForgotPassword' }">
            <p class="text-sm text-darkBlue pl-2 my-3">Forgot Your Password?</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "login",
  data() {
    return {
      newUser: "",
      domains: [],
      accountType: undefined,
      mainAccountType: "organization",
      onboardingType: "",
      savingAccountType: false,
      logisticsTitle: "Login as a Logistics Provider",
      customerTitle: "Individual",
      accountGroup: "",
      hasType: false,
      user: {
        accountId: "",
        email: "",
        password: "",
      },
      accountTypeObject: {},
      remember: false,
      validation: {
        isValidEmail: false,
        isValidPassword: false,
      },
      loggingIn: false,
    };
  },
  computed: {
    isValidForm() {
      return this.validation.isValidEmail && this.validation.isValidPassword;
    },
  },
  methods: {
    selectAccountType(accountType, group, title) {
      this.accountGroup = group
      switch (group) {
        case "logistics":
          this.logisticsTitle = title;
          break;
        case "customer":
          this.customerTitle = title;
          break;
      }
      this.accountType = accountType;
      this.accountTypeObject = {
        mainAccountType: this.mainAccountType,
        accountType: this.accountType
      }
      this.hasType = true
    },
    toggleAccountType(accountType) {
      this.onboardingType = accountType;
      if (this.mainAccountType == accountType) {
        this.mainAccountType = "";
      } else {
        this.mainAccountType = accountType;
      }

      if (accountType == '3PL') {
        this.accountType = "organization"
        this.hasType = true
        this.accountTypeObject = {
          mainAccountType: accountType,
          accountType: "organization"
        }
      }
    },
    async login() {
      if(!this.validation.isValidEmail) return;
      this.loggingIn = true;

      try {
        let response = await this.$_login(this.user);
        this.loggingIn = false;
        this.handleSuccessfulLogin(response);
        this.$store.dispatch('saveGoogleApiKey', process.env.VUE_APP_GOOGLE_AUTOCOMPLETE_API_KEY)
      } catch (error) {
        this.loggingIn = false;
        // Navigate user to otp page if registration is not complete
        if (error?.response?.status === 307 && error?.response?.data?.data?.redirect &&
          (error?.response?.data?.data?.type === 'incomplete_password' ||
            error?.response?.data?.data?.type === 'incomplete_user_type')
        ) {
          this.$router.push(`/signup/authentication`);
        } else {
          this.handleError(error);
        }
      }
    },
    handleSuccessfulLogin(response) {
      const { user, token, quantumToken } = response.data.data;
      if (this.accountTypeObject.accountType === "enterprise_customer") {
        this.accountTypeObject.accountType = "organization"
      }
      if(user.onboardingtype === "3PL" && user.accounttype == "individual") {
        this.accountTypeObject.accountType = "individual"
      }
      console.log(user, user.accountType, this.accountTypeObject)
      if ((user.onboardingtype !== this.accountTypeObject.mainAccountType || user.accounttype !== this.accountTypeObject.accountType) && !user.twoFA) {
        this.handleError({ response: { data: { message: "Wrong login format!" } } })
        return
      }

      if (this.remember) {
        this.performRememberAction(this.user);
      } else {
        sessionStorage.clear();
      }

      if (user.twoFA) {
        localStorage.setItem("userId", user.id);
        localStorage.setItem("quantumToken", quantumToken);
        localStorage.setItem("loginPayload", JSON.stringify(response));
        this.$router.push({ name: "VerifyOtp" });
      } else if (user.securityques && user.securityques.length) {
        this.$router.push({ name: "VerifySecurityQuestion" });
        localStorage.setItem("loginPayload", JSON.stringify(response));
      } else {
        this.$store.dispatch("handleSuccessfulLogin", {
          user,
          token,
          quantumToken,
        });

        if (user.onboardingtype == "ondemand") {
          this.$router.push("/dashboard");
        } else {
          this.$router.push({ name: "3plDashboard" });
        }
        this.generateToast(`Welcome ${user.firstname}`, "success");
      }
    },

    showPassword(passwordField) {
      var password = document.getElementById(passwordField);
      if (password.type === "password") {
        password.type = "text";
      } else {
        password.type = "password";
      }
    },
    performRememberAction(credentials) {
      sessionStorage.setItem("domain", credentials.domain);
      sessionStorage.setItem("password", credentials.password);
      sessionStorage.setItem("email", credentials.email);
      sessionStorage.setItem("remember", this.remember);
    },
  },
  mounted() {
    const savedCredentials = sessionStorage.getItem("remember");
    if (savedCredentials === "true") {
      this.user.email = sessionStorage.getItem("email");
      this.user.password = sessionStorage.getItem("password");
      this.user.domain = sessionStorage.getItem("domain")
        ? sessionStorage.getItem("domain")
        : " ";
      this.remember = true;
    }
  },
};
</script>

<style scoped>
.actions {
  position: absolute;
  background: #ffffff;
  top: 80px;
  z-index: 999;
  font-size: 0.9rem;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;
  padding: 1rem;

  span {
    padding-right: 0.25rem;
  }

  >div {
    display: flex;
    align-items: center;
    padding: 0.75rem;

    &:hover {
      background: rgb(225, 225, 225);
    }
  }

  .disabled {
    opacity: 0.5;

    &:hover {
      background: none;
    }
  }
}

.single-option {
  width: 100%;
  height: 4.5rem;
  border-radius: 5px;
  margin: 0.75rem 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
  /* transition: transform ease 0.5s; */
  border: 1px solid #dae8f6;
  position: relative;
}

.single-option.selected {
  border: none;
  background: #fbc210;
}

.groupselected {
  border: none;
  background: #fbc210;
}

.single-option__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;
  padding: 0 0.5rem;
  width: 100%;
  height: 70%;
  border-radius: 5px;
}

/* .single-option.selected .single-option__inner {
} */

.single-option__select-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 0.5px solid #eff2f7;
}

.single-option__select-circle__inner {
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background: #eff2f7;
}

.disabled-option {
  color: rgba(174, 174, 185, 0.956);
  background-color: #e7e7e9;
}

@media screen and (max-width: 768px) {
  .single-option {
    width: 90vw;
  }
}

.disabled-option {
  @apply py-2 my-4 pr-3 cursor-pointer;
}

.active-tab {
  @apply text-primary-black bg-primary-yellow;
}
</style>
